import React from "react";

export const FlagIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.7962 2.79037C12.7962 4.92982 12.7962 7.06968 12.7962 9.20913C9.35407 6.64146 5.91279 11.7768 2.47066 9.20913C2.47066 7.06968 2.47066 4.92982 2.47066 2.79037C5.91279 5.35762 9.35407 0.222694 12.7962 2.79037ZM1.42417 0C0.749812 0 0.203125 0.546688 0.203125 1.22105C0.203125 1.70746 0.489864 2.12354 0.900926 2.31986V15H1.94742V2.31986C2.35848 2.12354 2.64522 1.70746 2.64522 1.22105C2.64522 0.546269 2.09895 0 1.42417 0Z"
      fill="currentColor"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SellerSection/FlagIcon.tsx